import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class EesDesService {
  tokenFromUI:string = "TYASuite!#!TYASuite!TYASuite!#!@";
  constructor() { }

set(value,key?:string)
{
  // console.log(value);
  // console.log(key);
// try{
//   if(localStorage.getItem('is_enc_on')=='MQ=='||key=='is_enc_on'||key=='is_login_psw')
//   // if(localStorage.getItem('is_enc_on')=='MQ==')
//   {
//     return btoa(value);
//   }
//   else
//   {
//     return value
//   }
// }
// catch(e)
// {
// return value
// }
let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI).toString();
try{
   if(localStorage.getItem('is_enc_on')=='rL1SUvvPuiEUY30i7mxdOg=='||key=='is_enc_on'||key=='is_login_psw')
   {
    return CryptoJS.AES.encrypt(value.trim(),_key,{keySize: 256,iv:_iv, mode: CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7}).toString();
   }
  }
   catch(e)
   {
     console.log(e.name);
     console.log(e.message);
return value
   }

}
handelSetError(value,errorType,key?:string)
{
if(errorType=='InvalidCharacterError')
{
  // console.log(this.b64EncodeUnicode(value))
  return this.b64EncodeUnicode(value)
  // return value
}
return value
}
b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
      return String.fromCharCode(parseInt(p1, 16))
  }))
}
get(key,value,is_cookie?:string)
{
//   try {
//   if(localStorage.getItem(key)!=null && localStorage.getItem(key)!='' && localStorage.getItem(key)!=undefined && localStorage.getItem('is_enc_on')=='MQ==')
//   {
//     // console.log('hey3');

//     return (atob(value)!=''&&atob(value)!=undefined&&atob(value)!=null)?(this.isJSON(atob(value))?JSON.parse(atob(value)):atob(value)):value;

//   }
//   else
//   {
//     return (this.isJSON(value)?JSON.parse(value):value);
//   }
// }
// catch(e)
// {
//   console.error('enc/dec logout key'+key,'value='+value)
//   window.localStorage.clear();
//   window.location.href=window.location.origin+"/#/login"
// }
let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI).toString();
try {
  if(localStorage.getItem(key)!=null && localStorage.getItem(key)!='' && localStorage.getItem(key)!=undefined && (localStorage.getItem('is_enc_on')=='rL1SUvvPuiEUY30i7mxdOg=='&&is_cookie!='1'))
  {
    let dec:any=CryptoJS.AES.decrypt(value.trim(),_key,{keySize: 256,iv:_iv, mode: CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7}).toString(CryptoJS.enc.Utf8)
    return this.isJSON(dec)?JSON.parse(dec):dec;
  }
  if(is_cookie=='1')
  {
    //console.log('is_cookie='+is_cookie+'key='+key)
    let dec:any=CryptoJS.AES.decrypt(value.trim(),_key,{keySize: 256,iv:_iv, mode: CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7}).toString(CryptoJS.enc.Utf8)
    return this.isJSON(dec)?JSON.parse(dec):dec;
  }
  }
  catch(e)
  {
    console.error('enc/dec logout key'+key,'value='+value)
      window.localStorage.clear();
      window.location.href=window.location.origin+"/#/login"
  }
}
isJSON(str) {
  try {
      return (JSON.parse(str));
  } catch (e) {
      return false;
  }
}
setBuffer(value)
{
  // return Buffer.from(value).toString('base64')
}
getBuffer(value)
{
  // return Buffer.from(value, 'base64').toString('binary')

}
}



// WEBPACK FOOTER //
// /codebuild/output/src3885095922/src/src/app/shared/services/ees-des.service.ts